"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearch = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
const utility_1 = require("../utility");
const useSearch = () => {
    const { options, config, search } = (0, hooks_1.useReactifySearchContext)();
    const handleSubmitSearchTerm = react_1.default.useCallback((searchTerm = search.searchTerm) => {
        utility_1.debug.log("useSearch", "submitSearchTerm[query]", searchTerm);
        if (!searchTerm) {
            return;
        }
        const redirect = config.redirects.find((redirect) => redirect.query.trim().toLowerCase() ===
            searchTerm.trim().toLowerCase());
        if (redirect) {
            utility_1.debug.log("useSearch", "submitSearchTerm[redirect]", redirect);
        }
        search.setShowInstantSearchResults(false);
        if (options.onRedirect) {
            options.onRedirect(redirect ? "redirect" : "search", redirect
                ? redirect.url
                : `/search?q=${encodeURIComponent(searchTerm)}`);
        }
        else if (redirect) {
            window.location.href = redirect.url;
        }
        else {
            window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
        }
    }, [search.searchTerm]);
    const handleSetSearchTerm = react_1.default.useCallback((searchTerm = "") => {
        utility_1.debug.log("useSearch", "setSearchTerm[searchTerm]", searchTerm);
        search.setSearchTerm(searchTerm);
    }, [search.searchTerm]);
    return {
        searchTerm: search.searchTerm,
        setSearchTerm: handleSetSearchTerm,
        submitSearchTerm: handleSubmitSearchTerm,
        showInstantSearchResults: !!search.showInstantSearchResults && !!search.searchTerm,
        setShowInstantSearchResults: search.setShowInstantSearchResults,
    };
};
exports.useSearch = useSearch;
//# sourceMappingURL=useSearch.js.map